import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { Contribution, ContributionLine, Message } from 'app/core/model/entity-model';
import { Utility } from 'app/core/utility';
import { DetailComponent } from 'app/messages/detail/detail.component';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { confirm } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BankAmountDialogComponent } from '../bank-amount-dialog/bank-amount-dialog.component';
import { BatchEditDialogComponent } from '../batch-edit-dialog/batch-edit-dialog.component';
import { BulkContributionDialogComponent } from '../bulk-contribution-dialog/bulk-contribution-dialog.component';
import { CashListComponent } from '../cash-list/cash-list.component';
import { ContributionEditDialogComponent } from '../contribution-edit-dialog/contribution-edit-dialog.component';
import { DoubleCheckDialogComponent } from '../double-check-dialog/double-check-dialog.component';

@Component({
    selector: 'app-batch-detail',
    templateUrl: './batch-detail.component.html',
    styleUrls: ['./batch-detail.component.scss'],
    standalone: false,
})
export class BatchDetailComponent implements OnInit {
    batchId: number;
    entity: any;
    contributions: any[];
    includeAccounts: any[];
    userAccess = false;
    showAllContributions = false;
    currentUser: any;
    readonly = true;
    reviewOnly = true;
    statuses: any[];
    types: any[];
    canChangeStatus = false;
    batchNotes: any[];

    message: Message;
    fromOptions: any = ['General Email'];
    from: any;
    baseHref = environment.baseHref;
    serviceName = environment.serviceName;
    froalaOptions = {
        key: environment.froalaKey,
        heightMin: 250,
        heightMax: 750,
        imageUploadURL: `${environment.serviceName}/api/utility/uploadMessageImage`,
        useClasses: false,
        events: {
            initialized: (editor) => {
                editor.getEditor().edit.off();
            },
        },
    };

    constructor(
        private uow: ArkUnitOfWork,
        private route: ActivatedRoute,
        public auth: AuthService,
        private modalService: BsModalService,
        protected router: Router,
        private http: HttpClient,
        public appInfo: AppInformationService
    ) {}

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();

        this.batchId = this.route.snapshot.params['id'];
        this.statuses = await this.uow.contributionBatchStatuses.all();
        this.types = this.uow.getContributionTypes();

        await this.uow.getPeopleForGiving();
        await this.getBatch(this.batchId);

        this.appInfo.pleaseWaitHide();
    }

    async getBatch(batchId: number) {
        this.entity = null;
        this.getContributions(batchId);
        this.entity = await this.uow.getBatchInfo(batchId);
        this.getIncludeAccounts();
        this.batchNotes = await this.uow.getBatchNotes(batchId);

        this.readonly = this.entity.statusId !== 1 && this.entity.statusId !== 5 && !this.auth.hasRole('Treasurer') && !this.auth.hasRole('Deacon');
        if (this.appInfo.graafschap)
            this.reviewOnly = this.auth.hasRole('Administrator') || this.auth.hasRole('Secretary') || (this.entity.statusId !== 1 && this.entity.statusId !== 5);
        else this.reviewOnly = this.entity.statusId === 2;
        this.canChangeStatus =
            this.appInfo.graafschap &&
            (this.auth.hasRole('Secretary') || this.auth.hasRole('Administrator')) &&
            (this.entity.statusId === 1 || this.entity.statusId === 2 || this.entity.statusId === 6);
        // console.log('batch',this.entity);
    }

    async getContributions(batchId: number) {
        let count = null;
        if (!this.showAllContributions) count = 5;
        this.contributions = null;
        this.contributions = (await this.uow.getContributions(batchId, count)) as any[];
    }

    async getTotalBatchCash(batchId: number) {
        const batchCash = await this.uow.getBatchCashSummary(this.batchId);

        const modalRef = this.modalService.show(CashListComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                mode: 'summary',
                contributionCash: batchCash,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result) {
            }
        });
    }

    getIncludeAccounts() {
        this.includeAccounts = this.uow.includeAccounts();
        if (this.entity.specialAccount) this.includeAccounts.push(this.entity.specialAccount);
    }

    async post() {
        if (await confirm('Are you sure you want to finalize and post this batch?', 'Post Batch')) return this.updateBatchStatus(this.entity.id, 2);
    }

    async voidBatch() {
        if (await confirm('Are you sure you want to void this batch?', 'Void Batch')) return this.updateBatchStatus(this.entity.id, 4);
    }

    async changeStatus() {
        if (!this.entity && this.entity.statusId !== 1 && this.entity.statusId !== 2 && this.entity.statusId !== 6) return;
        const batch = await this.uow.contributionBatches.byId(this.batchId);
        batch.statusId = batch.statusId === 1 ? 2 : 3;
        await this.uow.commit();
        // this.entity = await this.uow.getBatchInfo(this.batchId);
        await this.getBatch(this.batchId);
    }

    async markAsTreasurerReview() {
        if (!this.entity && this.entity.statusId !== 1 && this.entity.statusId !== 2) return;
        const batch = await this.uow.contributionBatches.byId(this.batchId);
        batch.statusId = 6;
        await this.uow.commit();
        await this.getBatch(this.batchId);
    }

    async editBatch() {
        const previousSpecialAccountId = this.entity.specialAccountId;
        const modalRef = this.modalService.show(BatchEditDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: { batchId: this.batchId },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result) {
                this.entity = await this.uow.getBatchInfo(this.batchId);
                // console.log('pId', previousSpecialAccountId);
                // console.log('eId', this.entity.specialAccountId);
                if (this.appInfo.graafschap) {
                    if (previousSpecialAccountId !== this.entity.specialAccountId) {
                        this.showAllContributions = true;
                        await this.getContributions(this.batchId);
                        if (!!this.contributions) {
                            this.contributions.forEach((contribution) => {
                                contribution.lines.forEach((line) => {
                                    if (line.accountId === previousSpecialAccountId) {
                                        line.accountId = this.entity.specialAccountId;
                                    }
                                });
                            });
                        }
                    }
                    await this.uow.commit();
                    this.entity = await this.uow.getBatchInfo(this.batchId);
                }
            }
        });
    }

    async bulkAdd() {
        const modalRef = this.modalService.show(BulkContributionDialogComponent, {
            class: 'modal-mdw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                batchId: this.batchId,
                specialAccountId: this.entity.specialAccountId,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result) {
                await this.getBatch(this.batchId);
            }
        });
    }

    addContribution() {
        const contribution = this.uow.manager.createEntity('Contribution', {
            batchId: this.batchId,
            created: new Date(Date.now()),
        }) as Contribution;
        if (this.appInfo.neland) contribution.typeId = (_(this.types).find({ name: 'Check' } as any) as any).id;

        this.includeAccounts.forEach((account) => {
            const line = this.uow.manager.createEntity('ContributionLine') as ContributionLine;
            line.account = account;
            contribution.lines.push(line);
        });
        this.editContribution(contribution);
    }

    async editContributionById(contributionId: number) {
        const contribution = await this.uow.getContribution(contributionId);
        // this.includeAccounts.forEach(account => {
        //     if (_(contribution.lines).some({ accountId: account.id })) return;

        //     const line = this.uow.manager.createEntity('ContributionLine') as ContributionLine;
        //     line.account = account;
        //     contribution.lines.push(line);
        // });
        this.editContribution(contribution);
    }

    editContribution(contribution: any) {
        const modalRef = this.modalService.show(ContributionEditDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                contribution,
                batchId: this.batchId,
                specialAccountId: this.entity.specialAccountId || 1,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result) {
                await this.getBatch(this.batchId);
                // this.dataGrid.instance.refresh();
            }
        });
    }

    async bankAmount() {
        const modalRef = this.modalService.show(BankAmountDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: { batchId: this.batchId },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result) {
                await this.getBatch(this.batchId);
            }
        });
    }

    async batchError(resolve?: boolean, noteOnly?: boolean) {
        if (!noteOnly) {
            const result = await confirm(
                `${resolve ? 'Are you sure you want to RESOVLE this batch error?' : 'Are you sure you want to mark this batch with an error?'}`,
                `Graafschap CRC`
            );
            if (!result) return;
        }
        const userNote = await this.batchNote();
        if (!userNote) return;

        let success = false;
        // if (!noteOnly) {
        try {
            success = await this.batchErrorEmail(userNote, resolve, noteOnly);
        } catch (error) {
            this.appInfo.pleaseWaitHide();
            console.log('emailerror', error);
        }
        if (!success) return;
        // }

        const batch = await this.uow.contributionBatches.byId(this.batchId);
        if (!noteOnly) batch.statusId = resolve ? 1 : 5;
        const note = this.uow.contributionBatchNotes.createEntity() as any;
        note.batchId = batch.id;
        note.createdBy = this.auth.currentUser.userName;
        note.note = userNote;
        note.created = moment(new Date()).format('MM/DD/YYYY hh:mm:ss');
        await this.uow.commit();
        await this.getBatch(this.batchId);
    }

    async batchNote(): Promise<string> {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Batch Note',
                dialogPrompt: 'Enter Batch Note: ',
                mode: 'textarea',
            },
        });

        const promise = new Promise<string>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (!!result && result.value) {
                }
                modalRef.hide();
                resolve(result.value);
            });
        });
        return promise;
    }

    async batchErrorEmail(userNote: string, resolve: boolean, noteOnly?: boolean): Promise<boolean> {
        const groups = await this.uow.groups.all('name');
        const deaconsGroup = this.appInfo.serviceName.includes('localhost') ? _.find(groups, { name: 'zTesting' }) : _.find(groups, { name: 'DeaconsARK' });
        // this.fromOptions.push(this.auth.currentUser.userName);

        const cashAmount = _.find(this.entity.typeTotals, { name: 'Cash' }) ? _.find(this.entity.typeTotals, { name: 'Cash' }).totalAmount : 0;
        const checkAmount = _.find(this.entity.typeTotals, { name: 'Check' }) ? _.find(this.entity.typeTotals, { name: 'Check' }).totalAmount : 0;
        const bankCash = this.entity.bankCashAmount ? this.entity.bankCashAmount : 0.0;
        const bankCheck = this.entity.bankCheckAmount ? this.entity.bankCheckAmount : 0.0;

        this.message = this.uow.messages.createEntity({ created: moment().toDate() });
        this.message.fromUserId = this.auth.currentUser.id;
        this.message.toGroup = deaconsGroup;
        this.message.subject = `Batch ${resolve ? 'Resolved' : noteOnly ? 'Note' : 'Error'} - ID: ${this.entity.id} -- ${this.entity.name}`;

        let body = '';

        if (!resolve && !noteOnly) {
            // default for a batch error
            body = `There was an error with the following Batch:<br>
            Batch Id: ${this.entity.id}<br>
            Name: ${this.entity.name}<br>
            Cause: ${this.entity.specialAccount ? this.entity.specialAccount?.name : 'No Account Set'}<br>
            By: ${this.auth.currentUser.userName}<br>

            ARK Cash:  ${cashAmount} -- Bank Cash: ${bankCash}  -- Difference: ${Utility.round(Math.abs(cashAmount - bankCash), 2).toFixed(2)}<br>
            ARK Check: ${checkAmount} -- Bank Check: ${bankCheck}  -- Difference: ${Utility.round(Math.abs(checkAmount - bankCheck), 2).toFixed(2)}<br>
            Additional Notes:<br>${userNote}`;
        } else {
            body = `${resolve ? 'Resolution' : 'Note'} for the following Batch:<br>
            Batch Id: ${this.entity.id}<br>
            Name: ${this.entity.name}<br>
            Cause: ${this.entity.specialAccount ? this.entity.specialAccount?.name : 'No Account Set'}<br>
            By: ${this.auth.currentUser.userName}<br>

            ${resolve ? 'Resolution ' : ''}Notes:<br>${userNote}`;
        }
        this.message.body = body;

        const promise = new Promise<boolean>(async (resolve, reject) => {
            const modalRef = this.modalService.show(DetailComponent, {
                class: 'modal-lg',
                ignoreBackdropClick: true,
                keyboard: false,
                initialState: {
                    showAsDialog: true,
                    mode: 'drafts',
                    message: this.message,
                },
            });

            modalRef.content.result.subscribe(async (result) => {
                if (result) {
                }
                modalRef.hide();
                resolve(result.success);
            });
        });
        return promise;
    }

    async doubleCheck() {
        const modalRef = this.modalService.show(DoubleCheckDialogComponent, {
            class: 'modal-xl',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                batchId: this.batchId,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result) {
                await this.getBatch(this.batchId);
            }
            modalRef.hide();
        });
    }

    async copy() {
        const result = await confirm('Are you sure you want to copy this batch?', 'Copy Batch');

        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const batch = await this.uow.contributionBatches.byId(this.batchId, 'contributions, contributions.lines');
        const contributions = batch.contributions.slice();
        batch.name = batch.name + ' - copy';
        batch.statusId = 1;

        this.uow.addEntity(batch);

        let count = 0;

        contributions.forEach((contribution) => {
            count++;
            // if (count % 50 === 0) common.logger.log(count + ' contributions copied', null, controllerId, true);
            const lines = contribution.lines.slice();
            this.uow.addEntity(contribution);
            contribution.batch = batch;
            lines.forEach((line) => {
                this.uow.addEntity(line);
                line.contribution = contribution;
            });
        });

        await this.uow.commit();

        this.router.navigate(['../' + batch.id], {
            relativeTo: this.route,
            replaceUrl: true,
        });
    }

    toggleShowAll() {
        this.showAllContributions = !this.showAllContributions;
        this.getContributions(this.batchId);
    }

    summaryReport() {
        const url = environment.serviceName + '/reports/batchSummary/' + this.batchId;
        window.open(url);
    }

    async updateBatchStatus(batchId: number, statusId: number) {
        const batch = await this.uow.contributionBatches.byId(batchId);
        batch.statusId = statusId;
        await this.uow.commit();
        if (statusId === 2 && this.appInfo.neland) {
            await this.http.post(environment.serviceName + '/api/utility/BatchPostNotification', null).toPromise();
        }
        this.router.navigate(['../'], { relativeTo: this.route });
    }

    close() {
        this.router.navigate(['../'], { relativeTo: this.route });
    }

    addPayment() {}
}
